module.exports = __webpack_public_path__ + "img/zhobo.859a5378.png";